import { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileSpreadsheet } from 'lucide-react';

interface DataImportWorkspaceProps {
  projectName: string;
  projectId: string;
  children: ReactNode;
}

/**
 * DataImportWorkspace - Unified responsive workspace container
 * 
 * Fix #1: Proper sidebar-aware layout to prevent overlap.
 * Fix #3: Viewport-based max-height to fit in single screen at 100% zoom.
 * Horizontal scroll contained ONLY within table wrapper, NOT page level.
 */
export default function DataImportWorkspace({
  projectName,
  projectId,
  children,
}: DataImportWorkspaceProps) {
  return (
    <div className="w-full max-w-full overflow-x-hidden">
      {/* Main container with viewport height constraint */}
      <div className="max-h-[calc(100vh-140px)] overflow-y-auto">
        <Card className="border-border shadow-sm">
          <CardHeader className="border-b border-border bg-muted/30 py-1.5 px-3">
            <div className="flex items-center gap-2">
              <div className="h-7 w-7 rounded-lg bg-primary/10 flex items-center justify-center">
                <FileSpreadsheet className="h-3.5 w-3.5 text-primary" />
              </div>
              <div>
                <CardTitle className="text-xs font-medium">Data Import</CardTitle>
                <p className="text-[10px] text-muted-foreground leading-tight">
                  {projectName || projectId}
                </p>
              </div>
            </div>
          </CardHeader>
          <CardContent className="p-0">
            <div className="divide-y divide-border">
              {children}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}